module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.shovValidate ? 'mainContainer show' : 'mainContainer'
  }, [_c('div', {
    class: _vm.valid ? 'dropdownWrapper complete' : 'dropdownWrapper incomplete'
  }, [_c('div', {
    class: _vm.opened ? "v_dropdown active" : "v_dropdown"
  }, [_c('div', {
    staticClass: "value",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    },
    on: {
      "click": _vm.opener
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "overflow"
  }, _vm._l((_vm.data.options), function(opt) {
    return _c('div', {
      class: _vm.active == opt.value ? "opt active" : "opt",
      domProps: {
        "innerHTML": _vm._s(opt.text)
      },
      on: {
        "click": function($event) {
          return _vm.setActive(opt)
        }
      }
    })
  }), 0)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ec41375"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/forms/elements/dropdown.vue
// module id = 357
// module chunks = 31